export default __webpack_public_path__ + "static/media/definicao-objetivos.ed8e9df7.svg";